const interceptFetch = (): void => {
  const originalFetch: typeof window.fetch = window.fetch;
  window.fetch = (
    url: RequestInfo | URL,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return originalFetch(url, options)
      .then((response: Response) => {
        // Post-request
        return response;
      })
      .catch((error) => {
        // Post-request
        throw error;
      });
  };
};
export default interceptFetch;
